.imageCropper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  &.flat {
    .area {
      border-radius: 0;

      @media (min-width: 769px) {
        border-radius: 0.625rem;
      }
    }

    .zoom {
      padding: 0 1.25rem;

      @media (min-width: 769px) {
        padding: 0;
      }
    }
  }

  .area {
    position: relative;
    width: 100%;
    height: 100%;
    margin: 0 auto 1.25rem;
    overflow: hidden;
    border-radius: 0.625rem;

    @media (min-width: 400px) {
      margin: 0 auto 1.5rem;
    }

    @media (min-width: 1025px) {
      margin: 0 auto 1.625rem;
    }
  }

  .zoom {
    flex: 0 0 auto;
  }
}
